// extracted by mini-css-extract-plugin
export var buttons = "FeaturesTableSection-module--buttons--3cd12";
export var outline = "FeaturesTableSection-module--outline--d8f12";